import moment from "moment";

export interface ProductFormState {
  mainArea: server.dto.MainAreas;
  parentId: number;

  productType: server.dto.ProductType;
  ledgerNumber: string;
  title: string;
  description: string;
  unit: string;
  quantity: number;
  date: moment.Moment | undefined;

  costPriceVat: server.dto.VatRate;
  costPricePerUnit: number;

  salesPriceVat: server.dto.VatRate;
  salesPricePerUnit: number;
}

export const mapProductToFormState = (
    product: server.dto.Product | null,
    vatRates: server.dto.VatRate[],
    serverReference: server.dto.ServerReference,
    mainArea: server.dto.MainAreas,
    parentId: number,
): ProductFormState => ({
  mainArea,
  parentId,

  productType: product?.productType ?? serverReference.productTypes.find(p => p.value === "undefined")!,
  ledgerNumber: product?.ledgerNumber.toString() ?? serverReference.constants.productTemplate.defaultLedgerNumber.toString(),
  title: product?.title ?? "",
  description: product?.description ?? "",
  unit: product?.unit ?? "",
  quantity: product?.quantity ?? 1,
  date: product?.date != null ? moment.utc(product.date).startOf("day") : undefined,

  costPriceVat: product?.costs?.vatRate != null
    ? vatRates.find(v => v.vatRateId === product.costs.vatRate.vatRateId)!
    : vatRates[0],
  costPricePerUnit: product?.costs?.pricePerUnit.amount ?? 0,

  salesPriceVat: product?.sales?.vatRate != null
    ? vatRates.find(v => v.vatRateId === product.sales.vatRate.vatRateId)!
    : vatRates[0],
  salesPricePerUnit: product?.sales?.pricePerUnit.amount ?? 0,
});

export const getProductInstruction = (
    state: ProductFormState,
): server.dto.CreateProductInstruction => ({
  costsPricePerUnit: state.costPricePerUnit,
  costsVatRateId: state.costPriceVat.vatRateId,
  date: state.date?.toDate(),
  description: state.description,
  ledgerNumber: Number(state.ledgerNumber),
  mainArea: state.mainArea,
  parentId: state.parentId,
  productType: state.productType.value,
  quantity: state.quantity,
  salesPricePerUnit: state.salesPricePerUnit,
  salesVatRateId: state.salesPriceVat.vatRateId,
  title: state.title,
  unit: state.unit,
});
